import React, { useEffect, useState } from "react";
import { Modal, TextField, PrimaryButton, IconButton } from "@fluentui/react";
import styles from "../../pages/chat/Chat.module.css";
import AssistantTypeCards from "../../components/AssistantTypeCards/AssistantTypeCards"; // Adjust the path to your UserTagPicker component
import { multiPurposeAssistantCreationData } from "../../lsts";
import { toast } from "react-toastify";
import { empty_new_group, gnewgroup, guser } from "../../interfaces";
import { genRandomStr } from "../../util_glob";
import { textFieldNewAssistantStyles, newAssistantModalStyles, analysisCloseButStyles} from "../../styles_glob";
import { FaWindowClose } from "react-icons/fa";

interface NewSpaceModalProps {
    isSpaceModalOpen: boolean;
    closeSpacesPanel: () => void;
    isNewSpaceInfoBip: boolean;
    user: guser;
    addSpace: (newGroup: gnewgroup) => void;
}

const AddSpaceModal: React.FC<NewSpaceModalProps> = ({ isSpaceModalOpen, closeSpacesPanel, isNewSpaceInfoBip, user, addSpace }) => {
    const [newSpace, setNewSpace] = useState<gnewgroup>(empty_new_group);

    const handleAddSpace = (specializedSettings?: any) => {
        let groupid = `${newSpace?.groupname}_${user.userId}_${genRandomStr(5)}`;
        if (isNewSpaceInfoBip == true) groupid = newSpace.id;

        setNewSpace({ ...newSpace, id: groupid });

        if (newSpace.groupname == "") {
            toast.error("Please enter an Assistant name");
            return;
        }
        if (isNewSpaceInfoBip == true && newSpace.id === "") {
            toast.error("Please enter an InfoBip ID");
            return;
        }
        addSpace({
            id: groupid,
            groupname: newSpace.groupname,
            description: newSpace.description,
            appid: newSpace.appid,
            scrt: newSpace.scrt,
            specializedSettings: specializedSettings || {}
        });
        closeSpacesPanel();
    };

    const handleChange = (field: keyof gnewgroup, value: string | number | boolean) => {
        setNewSpace(prev => ({ ...prev, [field]: value }));
    };

    const onStateChange = (state: string) => {
        if (state === "closed") {
            closeSpacesPanel();
        }
        setNewSpace(empty_new_group);
    };

    useEffect(() => {
        setNewSpace(empty_new_group);
    }, [isSpaceModalOpen]);

    return (
        <Modal
            isOpen={isSpaceModalOpen}
            onDismiss={closeSpacesPanel}
            isBlocking={false}
            isDarkOverlay={false}
            onDismissed={() => closeSpacesPanel()}
            containerClassName={styles.spaceAddModal}

            styles={newAssistantModalStyles}
            allowTouchBodyScroll={true}
            className={styles.spaceAddModalMain}
        >
            <div className={styles.modalNewAssistantTop}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>New Assistant</h3>
                    <IconButton
                        onClick={() => closeSpacesPanel()}
                        title="Close"
                        styles={analysisCloseButStyles}
                        className={styles.closeButICAnalysisMain}
                    >
                        <FaWindowClose size={36} />
                    </IconButton>
                </div>
                <TextField
                    styles={textFieldNewAssistantStyles}
                    label="Assistant Name"
                    defaultValue={newSpace.groupname}
                    onChange={(event, newValue) => handleChange("groupname", newValue || "")}
                    className={styles.spaceTextFieldsFirstAddAssistant}
                />
                <TextField
                    styles={textFieldNewAssistantStyles}
                    className={styles.spaceTextFieldsAddAssistant}
                    defaultValue={newSpace.description}
                    label="Assistant Description"
                    onChange={(event, newValue) => handleChange("description", newValue || "")}
                />
            </div>
            <div className={styles.newAssistantCardsContainer}>

                {isNewSpaceInfoBip && (
                    <TextField
                        styles={textFieldNewAssistantStyles}
                        type="password"
                        label="Bot ID"
                        value={newSpace.appid}
                        onChange={(event, newValue) => handleChange("appid", newValue || "")}
                    />
                )}
                {isNewSpaceInfoBip && (
                    <TextField
                        styles={textFieldNewAssistantStyles}
                        type="password"
                        label="App Secret"
                        value={newSpace.scrt}
                        onChange={(event, newValue) => handleChange("scrt", newValue || "")}
                    />
                )}
                <h4 className={styles.modalMain}>What will the assistant do?</h4>

                <div className={styles.assitantCardsContainer}>
                    <div className={styles.assitantCardsSubSection}>
                        <h4 className={styles.modalSubSub}>AI Consulting</h4>
                        <AssistantTypeCards addSpace={handleAddSpace} section_filter={"Company Documents"} />
                    </div>

                    <div className={styles.assitantCardsSubSection}>
                        <h4 className={styles.modalSubSub}>Content Processing</h4>
                        <AssistantTypeCards addSpace={handleAddSpace} section_filter={"Content Processing"} />
                    </div>

                    <div className={styles.assitantCardsSubSection}>
                        <h4 className={styles.modalSubSub}>Conversational</h4>
                        <AssistantTypeCards addSpace={handleAddSpace} section_filter={"Audio"} />
                    </div>
                    <div className={styles.assitantCardsSubSection}>
                        <h4 className={styles.modalSubSub}>Video</h4>
                        <AssistantTypeCards addSpace={handleAddSpace} section_filter={"Video"} />
                    </div>
                    <div className={styles.assitantCardsSubSection}>
                        <h4 className={styles.modalSubSub}>Integrators</h4>
                        <AssistantTypeCards addSpace={handleAddSpace} section_filter={"Integrators"} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddSpaceModal;
